<template>
    <div :class="$common.getClassName('package-index-componesnts')" v-if="packagelistDone">
        <div :class="$common.getClassName('package-method-title cursor-pointer')">
            <span v-for="item in GET_PACKAGE_TAB_DATA.tabValue" @click="CLICK_USER_PACKAGES_TAB(item)" :class="item ===GET_PACKAGE_TAB_DATA.tab?'active':''">{{$t(`tab_${item}`)}}<i></i></span>
        </div>
        <div :class="$common.getClassName('package-cont-text')"></div>
        <div :class="$common.getClassName('package-cont-content')">
            <div :class="$common.getClassName('package-packs')" v-show="GET_PACKAGE_TAB_DATA.tab === 'pack'"><Packs></Packs></div>
            <div :class="$common.getClassName('package-props')" v-show="GET_PACKAGE_TAB_DATA.tab === 'prop'"><Props></Props></div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import Props from "./props/Index"
import Packs from "./packs/Index"
import lodash from "lodash";

export default {
    name: 'packageBox',
    components: {
        Props,
        Packs

    },
    data() {
        return {
            tab : 'props',
            lodash : lodash
        };
    },
    computed: {
        ...mapState(['$modulList','$common']),
        ...mapState('Module_Package', ['packagelist', 'packagelistDone']),
        ...mapGetters('Module_Package', ['GET_PACKAGE_PACKS_DATA','GET_PACKAGE_PROPS_DATA','GET_PACKAGE_TAB_DATA'])
    },

    created() {
        console.info(this.GET_PACKAGE_TAB_DATA)
    },

    watch:{

    },

    methods: {
        ...mapActions('Module_Package', ['CLICK_USER_PACKAGES_TAB']),
    }
};
</script>

<style type="scss">
</style>



// WEBPACK FOOTER //
// website/components/package/Index.vue